import React from "react";

/**
 * En-tête standard des pages applicatives desktop.
 *
 * Ce composant reste volontairement masqué sous 768 px afin de ne pas
 * modifier les expériences mobiles existantes pendant le chantier web.
 */
export default function DesktopPageHeader({
  eyebrow,
  title,
  description,
  icon: Icon,
  actions = null,
  className = "",
  testId = "desktop-page-header",
}) {
  return (
    <header
      className={`acta-desktop-page-header ${className}`.trim()}
      data-testid={testId}
    >
      <div className="acta-desktop-page-header-copy">
        <div className="acta-desktop-page-header-eyebrow">
          {Icon && (
            <Icon
              size={15}
              weight="duotone"
              aria-hidden="true"
            />
          )}
          <span>{eyebrow}</span>
        </div>

        <h1 className="acta-desktop-page-header-title">
          {title}
        </h1>

        {description && (
          <p className="acta-desktop-page-header-description">
            {description}
          </p>
        )}
      </div>

      {actions && (
        <div className="acta-desktop-page-header-actions">
          {actions}
        </div>
      )}
    </header>
  );
}
